import { AdditionalQualifier } from './table-state.model'
import { SoftFilter } from './softfilter'

export class ExternalFilter {
  /**
   * A hard filter (used in Table Data of dynamic tables) will be additionally applied when filtering for Entities.
   * it can be set in DTOConfig field definitions as referenceFilter (example for field initStateId in StateMachine to open a DTO selection just with states for this state machine):
   *
   * { ..., "referenceFilter": "EQ('stateMachineId', ${ENTITY.id})", ...}
   *
   * or in the DTOTiles when selecting one tile.
   *
   * like in the above example, a hardFilter might contain snippets which need to be evaluated with context (The Statemachine ENTITY is not known in the Dynamic Table for the states)
   */
  hardFilter: AdditionalQualifier
  softFilter: SoftFilter

  constructor(hardFilter: AdditionalQualifier, softFilter: SoftFilter) {
    this.hardFilter = hardFilter
    this.softFilter = softFilter
  }
}
